import React from 'react';

const Ads = (params) => {
  params = params || {};

  var id = params.id;
  var img = params.img;
  var url = params.url + (params.url.indexOf("?") != -1 ? "&" : "?") + "adid=" + params.adid;
  var style = (params.style || "") != "" ? JSON.parse(params.style) : null;

  return (
    <a key="{id}" href={url}>
      <img src={img} style={style} />
    </a>
  );
};

export { Ads };